import { Button, Dropdown, Icon } from '@wyz/ui';
import { Link } from 'react-router';

import { useApplicationContext, useConfig, Trans } from '~/common/context';
import { BlobHelpers } from '@wyz/utils';

export default function ExportImportAction() {
  const { apiUrl, tenantCode } = useConfig();
  const { auth } = useApplicationContext();

  return (
    <Dropdown.Container>
      <Dropdown.Toggle bsPrefix='toggle' as='div' id='import-export-actions'>
        <Button
          id='import-export-actions-btn'
          onClick={() => {}}
          variant='primary'
        >
          <Icon icon='arrow-down' />
          <span>
            {' '}
            <Trans i18nKey='app.user.actions.import_export' />
          </span>
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end'>
        <Dropdown.Item
          onClick={() =>
            BlobHelpers.download({
              url: `${apiUrl}/tenants/api/wtb/tenants/${tenantCode}/users/export/model`,
              token: auth.user?.access_token ?? '',
            }).catch(() => {})
          }
          id={'export-users-template'}
        >
          <Trans i18nKey='app.user.actions.export_template' />
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() =>
            BlobHelpers.download({
              url: `${apiUrl}/tenants/api/wtb/tenants/${tenantCode}/users/export`,
              token: auth.user?.access_token ?? '',
            }).catch(() => {})
          }
          id={'export-users-data'}
        >
          <Trans i18nKey='app.user.actions.export_data' />
        </Dropdown.Item>
        <Dropdown.Item as={Link} to='import' id={'import'}>
          <Trans i18nKey='app.user.actions.import' />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown.Container>
  );
}
